import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import {
  ACCOUNT_SETTINGS_PAGES,
  RESERVATIONS_SETTINGS_PAGE,
} from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';
import { useSelector } from 'react-redux';
import { ensureUser } from '../../util/data';
import { userHasAnnualStats } from '../../util/userAnnualStats';
import { isProviderUser } from '../../util/postAuthRedirect';

const UserNav = props => {
  const { className, rootClassName, currentPage } = props;
  const currentUser = ensureUser(useSelector(state => state?.user?.currentUser));
  const classes = classNames(rootClassName || css.root, className);

  const tabs = [
    // El panel de control es solo para anfitriones.
    ...(isProviderUser(currentUser)
      ? [
          {
            text: <FormattedMessage id="UserNav.dashboard" />,
            selected: currentPage === 'DashboardPage',
            linkProps: {
              name: 'DashboardPage',
            },
          },
        ]
      : []),
    {
      text: <FormattedMessage id="UserNav.yourListings" />,
      selected: currentPage === 'ManageListingsPage',
      linkProps: {
        name: 'ManageListingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.favouriteListings" />,
      selected: currentPage === 'FavouriteListingsPage',
      linkProps: {
        name: 'FavouriteListingsPage',
      },
    },
    // {
    //   text: <FormattedMessage id="UserNav.ReservaAntiguesPage"/>,
    //   selected: currentPage === 'ReservaAntiguesPage',
    //   linkProps: {
    //     name: 'ReservaAntiguesPage'
    //   }
    // },
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.reservationList" />,
      selected: RESERVATIONS_SETTINGS_PAGE.includes(currentPage) && currentPage !== 'IngresosPage',
      disabled: false,
      linkProps: {
        name: 'UpcomingListingsPage',
        params: { tab: 'sales' },
      },
    },
    ...(userHasAnnualStats(currentUser)
      ? [
          {
            text: <FormattedMessage id="UserNav.ingresos" />,
            selected: currentPage === 'IngresosPage',
            disabled: false,
            linkProps: {
              name: 'IngresosPage',
            },
          },
        ]
      : []),
  ];

  return (
    <LinkTabNavHorizontal
      className={classes}
      tabRootClassName={css.tab}
      currentUser={currentUser}
      tabs={tabs}
      skin="dark"
    />
  );
};

UserNav.defaultProps = {
  className: null,
  rootClassName: null,
};

const { string } = PropTypes;

UserNav.propTypes = {
  className: string,
  rootClassName: string,
  currentPage: string.isRequired,
};

export default UserNav;
